<div class="container">
  <div class="container-error">
    <div class="error-code">404</div>
    <h1 class="error-title">Página No Encontrada</h1>
    <p class="error-message">
      La página que está buscando puede haber sido eliminada, haber cambiado su
      nombre o no estar disponible temporalmente.
    </p>
    @if(showButton){
    <a [routerLink]="'/dashboard'" class="back-button"
      ><div class="container-button">
        <img src="../../../../assets/img/logo_icono.png" alt="" />
        <p>Volver a Inicio</p>
      </div>
    </a>
    }
  </div>
</div>
